import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import MUICheckIcon from '@mui/icons-material/Check';
import type { SvgIconComponent } from '@mui/icons-material';
import { styled, SxProps, Theme } from '../styles';
import Box from '../Box';
import BulletPointArrowIcon from './BulletPointArrowIcon';
import Typography, { Variant } from '../Typography';
import markerIconSize from './constants/markerIconSize';
type MarkerType = 'arrow' | 'check' | 'dot' | SvgIconComponent;
export interface Props {
  children: string | ReactNode;
  marker?: MarkerType;
  variant?: Variant;
  sx?: SxProps<Theme>;
}
const Li = styled('li')(({
  theme: {
    spacing
  }
}) => ({
  display: 'inline-flex',
  paddingRight: spacing(0.5),
  '&:not(:last-child)': {
    marginBottom: spacing(1)
  }
}));
const CheckIcon = styled(MUICheckIcon)(({
  theme: {
    palette
  }
}) => ({
  color: palette.icon.onMainHighlighted,
  width: markerIconSize,
  height: markerIconSize
}));
const Dot = styled('span')({
  display: 'inline-block',
  '&::before': {
    display: 'block',
    content: "'•'",
    width: markerIconSize,
    height: markerIconSize,
    textAlign: 'center'
  }
});
const iconByType = {
  arrow: BulletPointArrowIcon,
  check: CheckIcon,
  dot: Dot
};
const BulletPoint = t0 => {
  const $ = _c(15);
  const {
    children,
    marker: t1,
    variant: t2,
    sx
  } = t0;
  const marker = t1 === undefined ? "dot" : t1;
  const variant = t2 === undefined ? "body" : t2;
  const isCustomIcon = typeof marker !== "string";
  const Icon = isCustomIcon ? marker : iconByType[marker];
  let markerGap = 2;
  if (marker === "dot") {
    markerGap = 0;
  }
  if (marker === "arrow") {
    markerGap = 1;
  }
  let t3;
  if ($[0] !== markerGap || $[1] !== sx) {
    t3 = {
      gap: markerGap,
      ...sx
    };
    $[0] = markerGap;
    $[1] = sx;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isCustomIcon ? 1 : 0;
  let t5;
  if ($[3] !== t4) {
    t5 = {
      marginRight: t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== Icon || $[6] !== t5) {
    t6 = <Box component={Icon} data-testid="data-test-bullet-point-icon" sx={t5} />;
    $[5] = Icon;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children || $[9] !== variant) {
    t7 = typeof children === "string" ? <Typography variant={variant} dangerouslySetInnerHTML={{
      __html: children as string
    }} /> : children;
    $[8] = children;
    $[9] = variant;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t6 || $[13] !== t7) {
    t8 = <Li sx={t3}>{t6}{t7}</Li>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default BulletPoint;